import { UserAgentApplication } from "msal";

export const group = "391add73-f89f-4143-a157-bce93b5572a9";

export const app = new UserAgentApplication({
  auth: {
    clientId: "35ff7fb9-281d-4ccc-a25d-783a6ec680d9",
    authority:
      "https://login.microsoftonline.com/c0ce862b-4b4e-4e97-8074-1579f52f12d3"
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: true
  }
});

export const request = {
  scopes: ["Files.ReadWrite.All", "Directory.AccessAsUser.All"]
};

const endpoint = "https://graph.microsoft.com/v1.0";
export function getGraph(uri, method = "GET", body) {
  return app.acquireTokenSilent(request).then(res => {
    if (res.tokenType === "access_token") {
      return fetch(`${endpoint}/${uri}`, {
        method,
        headers: { Authorization: `Bearer ${res.accessToken}` },
        body
      }).then(res => {
        if (res.status === 204) return {};
        return res.json();
      });
    }
    throw new Error("not logged in");
  });
}



// WEBPACK FOOTER //
// ./src/model/graph.js